/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import QS from 'qs';
import store from '../store'
import { Message } from 'element-ui';
import { Loading } from 'element-ui';
import Vue  from 'vue';
import router from "../../src/router";


// 请求超时时间
axios.defaults.timeout = 10000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// loading框设置局部刷新，且所有请求完成后关闭loading框
let  loading
function startLoading(){
    loading = Loading.service({
        fullscreen:true,
        lock:true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background:'rgba(0, 0, 0, 0.3)'
    })
}

function endLoading(){
    loading.close()
}

// 声明一个对象用于存储请求个数
let needLoadingRequestCount = 0
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}


// 请求拦截器
axios.interceptors.request.use(    
    config => {
        //loading开始
        showFullScreenLoading()
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        const token = store.state.token;        
        token && (config.headers.Authorization = token);     
        tryHideFullScreenLoading()   
        return config;  
    },    
    error => {
        tryHideFullScreenLoading()        
        return Promise.error(error);    
    })

// 响应拦截器
axios.interceptors.response.use(    
    response => {
        tryHideFullScreenLoading()
        if (response.status === 200) {
            // console.log(response,'response');
            if(response.data.message.text == 'user_token verify fail'){
                localStorage.setItem('user_token','')
                router.replace({name:'Login'})
            }
            return Promise.resolve(response);        
        } else {            
            return Promise.reject(response);        
        }    
    },
    // 服务器状态码不是200的情况    
    error => {   
        tryHideFullScreenLoading()    
        if (error.response.status) {   
            console.log(error.response.status,'error.response.status');
            switch (error.response.status) {                
                // 401: 未登录                
                // 未登录则跳转登录页面，并携带当前页面的路径                
                // 在登录成功后返回当前页面，这一步需要在登录页操作。           
                case 401:            
                    this.$router.replace({                        
                        path: '/login',                        
                        query: { redirect: this.$router.currentRoute.fullPath } 
                    });
                    break;
                // 403 token过期            
                // 登录过期对用户进行提示                
                // 清除本地token和清空vuex中token对象                
                // 跳转登录页面       
                case 403:                     
                    // Toast({                        
                    //     message: '登录过期，请重新登录',                        
                    //     duration: 1000,                
                    //     forbidClick: true                 
                    // });
                    Message.error('登录过期，请重新登录')
                        
                    // 清除token                    
                    localStorage.removeItem('token');                    
                    store.commit('loginSuccess', null);                 
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    setTimeout(() => {                        
                        this.$router.replace({                            
                            path: '/login',                            
                            query: {
                                redirect: this.$router.currentRoute.fullPath 
                            }                        
                        });                    
                    }, 1000);                    
                    break; 
                // 404请求不存在                
                case 404:                    
                    // Toast({                        
                    //     message: '网络请求不存在',                        
                    //     duration: 1500,                        
                    //     forbidClick: true                    
                    // });
                    Message.error('网络请求不存在')                    
                break;
                //500 服务器错误
                case 500:
                    Message.error('500')
                break;                
                // 其他错误，直接抛出错误提示                
                default:                  
                    // Toast({                        
                    //     message: error.response.data.message,                        
                    //     duration: 1500,                    
                    //     forbidClick: true                    
                    // });
                    Message.error(error.response.data.message)          
            }            
            return Promise.reject(error.response);     
        }       
    }
);
/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */


export function get(url, params){  
    // console.log(localStorage.getItem('user_token'),'user_111111111111111');
    if(url == '/open/api/v1/access/token'){
         url = url
    }else{
         url = url + '?user_token='+localStorage.getItem('user_token')
    }
    return new Promise((resolve, reject) =>{
        axios.get(url, {            
            params: params
        })        
        .then(res => {            
            resolve(res.data);        
        })        
        .catch(err => {            
            reject(err.data)
        })
    });
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {  
    // console.log(localStorage.getItem('user_token'),'user_222222222');
    url = url + '?user_token='+localStorage.getItem('user_token')
    return new Promise((resolve, reject) => {         
        axios.post(url, params)        
        .then(res => {            
            resolve(res.data);        
        })
        .catch(err => {
            reject(err.data)        
        })    
    });
}
